import Component from '../abstracts/Component';
import Collapse from '../components/CollapseComponent';

export default class PreventDoubleClick extends Component {
  get SELECTORS() {
    return {
      form: '.prevent-double-click-form',
    };
  }

  constructor() {
    super();
  }


  bindEvents() {
    let ctx = this;

    $(document).on("submit", ctx.SELECTORS.form, function(e){
      $('button',e.target).attr("disabled","disabled");
    });

  }
  render() {
    this.bindEvents();
  }
}
